module.exports = __webpack_public_path__ + "img/Academics.c65ac5d3.svg";